import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

function ModalEnterpriseServices () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                Learn more
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Enterprise Services</Modal.Title>
            </Modal.Header>
            <Modal.Body>Solusi untuk menjaga agar perusahaan tetap kompetitif dalam operasional bisnis. 
                Mencakup solusi yang dapat: mengurangi biaya overhead, meningkatkan kinerja dan sinergi antar lini bisnis, 
                menyuguhkan informasi kepada pelanggan, memungkinkan manajemen mendapatkan gambaran singkat kondisi perusahaan dimanapun dan kapanpun.</Modal.Body>
                <Modal.Footer>
                    <div className="btn-toolbar">
                        <a 
                        style={{"color":"#fff","margin-left":"5px"}}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/watch?v=-2DbHX5Toic">
                            <button className="btn btn-primary btn-sm" >
                                Keynotes Video 1
                            </button>
                        </a>
                        <a 
                        style={{"color":"#fff","margin-left":"5px"}}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/watch?v=IUUtH1zeq6g">
                            <button className="btn btn-primary btn-sm" >
                                Keynotes Video 2
                            </button>
                        </a>
                    </div>
                    
                </Modal.Footer>
            </Modal>
        </div>
    );
}


export default ModalEnterpriseServices
